<footer class="footer bg-primary">
    <div class="container-fluid">
        <div class="row">
        <div class="col text-center">  
            <a href="#" (click)="openModalFiltres()" class="no-underline">
                <i class="fa-solid fa-filter fa-big"></i>
                <div class="small">Filtres</div>
            </a>
        </div>
        @if (userService.currentUser(); as user) {

            @if (user.write) {
                <div class="col text-center">              
                    <a [routerLink]="['/admin', 'person', 'list']" class="no-underline">
                        <i class="fa-solid fa-cogs fa-big"></i>
                        <div class="small">Administration</div>
                    </a>              
                </div>
            }


        }        
        
        <div class="col text-center">
            <a href="#" (click)="exportExcel()" class="no-underline">
                <i class="fa-solid fa-table-list fa-big"></i>
                <div class="small">Export</div>
            </a>
        </div>

        @if (!isAppInstalled) {
            <div class="col text-center">  
                <a href="#" (click)="installApp()" class="no-underline">
                    <i class="fa-solid fa-circle-down fa-big"></i>
                    <div class="small">Installer l'appli</div>
                </a>
            </div>
        }

        @if (userService.currentUser(); as user) {
            <div class="col text-center align-middle">              
                <a href="#" (click)="logout()" class="no-underline hint--top-left hint--rounded " aria-label="Déconnexion {{ user.username }}">
                    <i class="fa-solid fa-right-from-bracket fa-big"></i>
                    <div class="small">Déconnexion</div> 
                </a>
            </div>
        }
        </div>
    </div>   
</footer>
